import cn from "@/util/cn";
import { ComponentPropsWithRef } from "react";

export type SecondaryButtonGroupProps<T> = ComponentPropsWithRef<"div"> & {
  values: { value: T; title: string }[];
  selectedValue: T;
  onButtonPressed: (value: T) => void;
};

export function SecondaryButtonGroup<T>({
  values,
  selectedValue,
  onButtonPressed,
  className,
  ...otherProps
}: SecondaryButtonGroupProps<T>) {
  return (
    <div
      className={cn(
        "inline-flex w-fit divide-x divide-gray-300 overflow-hidden rounded-md border border-gray-300",
        className
      )}
      role="group"
      {...otherProps}
    >
      {values.map((value, index) => (
        <button
          key={`button-${index}`}
          className={cn(
            "cursor-pointer truncate bg-white px-4 py-2 text-sm font-medium",
            selectedValue === value.value
              ? "bg-brand text-primary/90"
              : "text-primary/90 hover:bg-gray-100 hover:text-primary"
          )}
          aria-pressed={selectedValue === value.value}
          onClick={() => onButtonPressed(value.value)}
        >
          {value.title}
        </button>
      ))}
    </div>
  );
}
